import { createContext, useContext } from 'react';

interface RecaptchaContextType {
    isLoaded: boolean;
    isLoading: boolean;
    error: string | null;
}

export const RecaptchaContext = createContext<RecaptchaContextType>({
    isLoaded: false,
    isLoading: false,
    error: null,
});

export const useRecaptcha = (): RecaptchaContextType => {
    const context = useContext(RecaptchaContext);

    if (!context) {
        throw new Error('useRecaptcha must be used within a RecaptchaProvider');
    }

    return context;
};
